// Stimulus
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

import application from "../src/stimulus"
import { startTomSelects } from "../src/tom_select"

application.load(definitionsFromContext(require.context("../player_controllers", true, /\.js$/)))
startTomSelects()
